import { Component, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * Catches render errors of a single screen so one broken page shows an error
 * card instead of white-screening the whole SPA (nav stays usable).
 */
class Boundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error('Screen crashed:', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 'var(--gap)' }}>
          <div
            role="alert"
            style={{
              padding: 24,
              background: 'var(--surface)',
              border: '1px solid var(--danger)',
              borderRadius: 'var(--r-2)',
            }}
          >
            <h3 style={{ margin: '0 0 8px', color: 'var(--danger)' }}>שגיאה בטעינת המסך</h3>
            <p style={{ margin: 0, color: 'var(--text-2)', fontSize: 'var(--t-sm)' }}>
              אירעה שגיאה לא צפויה. נסה לרענן את הדף או לעבור למסך אחר.
            </p>
            <button
              type="button"
              className="btn"
              style={{ marginTop: 12 }}
              onClick={() => window.location.reload()}
            >
              רענן
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

/** Boundary that resets automatically when the route changes. */
export function RouteErrorBoundary({ children }: Props) {
  const location = useLocation();
  return <Boundary key={location.pathname}>{children}</Boundary>;
}
